<template>
  <a class="mobile-logo" @click="clickHandler">
    <img
      v-if="isBackgroundPrimary && screenLevel === 'top'"
      src="../../assets/img/logo-mobile-white.png"
      alt
    />
    <img v-else src="../../assets/img/logo-mobile-green.png" alt />
  </a>
</template>

<script>
import { bus } from "../../main";

export default {
  name: "MobileLogo",
  props: {
    isBackgroundPrimary: Boolean,
    screenLevel: String
  },
  methods: {
    clickHandler: function(e) {
      e.preventDefault();
      bus.$emit("hidePost");
      bus.$emit("hidePP");
      bus.$emit("backgroundHandler");
    }
  }
};
</script>

<style lang="scss" scoped>
</style>